module.exports = __webpack_public_path__ + "static/18.1-29bf16ac87f6f12f575c802ff1b71d83.jpg";